import { ConditionalWrapper, PersonAvatar } from "client/Components";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { ReactElement } from "react";
import {
	UserIdentityModel,
	UserStatus,
	getUserProfileImageUrl
} from "client/Api/UserProfile/service";
import { HubUserInfoPopOver } from "../HubUserInfoPopOver/HubUserInfoPopOver";
import { generateTrackingId } from "client/Misc/utils";
import styles from "./HubAvatar.module.less";

export type HubAvatarProps = {
	authorUserInfo: UserIdentityModel;
	size?: "small" | "default";
	shouldShowContactDetails?: boolean;
	shouldBubbleClick?: boolean;
};

export const HubAvatar = (props: HubAvatarProps): ReactElement => {
	const {
		authorUserInfo,
		size = "default",
		shouldShowContactDetails = false,
		shouldBubbleClick = true
	} = props;

	const profileImageUrl: string | null = authorUserInfo.avatarId && getUserProfileImageUrl(authorUserInfo.avatarId);

	const { initials } = getComputedDisplayName({
		firstName: authorUserInfo.firstName,
		lastName: authorUserInfo.lastName,
		company: undefined,
		displayName: undefined,
		emailAddress: undefined,
		middleName: undefined,
		phoneNumber: undefined
	});

	const shouldShowPopover: boolean = shouldShowContactDetails
		&& (authorUserInfo.status === UserStatus.Active
			|| authorUserInfo.status === UserStatus.Inactive);

	return (
		<ConditionalWrapper
			condition={shouldShowPopover}
			wrapper={(children) => (
				<HubUserInfoPopOver
					trackingId={generateTrackingId("hub-avatar-with-contact-details", `|${authorUserInfo.userId}`)}
					userIdentity={authorUserInfo}
					shouldBubbleClick={shouldBubbleClick}
				>
					<div className={styles.hoverable}>
						{children}
					</div>
				</HubUserInfoPopOver>
			)}
		>
			<PersonAvatar
				trackingId="hub-avatar"
				size={size}
				initials={initials}
				imageSrc={profileImageUrl}
			/>
		</ConditionalWrapper>
	);
};

HubAvatar.displayName = "HubAvatar";